<template>
	<div>
		<div class="text-center mgs-scorecard-input font-bold" v-if="isReadOnly" v-html="fairwayValue"></div>
		<select v-else class="mgs-scorecard-input text-center" v-model="fairwayPos" @keydown.left="fairwayPos = 1">
			<option value="4">?</option>
			<option value="-1">&#10003;</option>
			<option value="1">&#8592;</option>
			<option value="2">&#8594;</option>
			<option value="0">&#8593;</option>
			<option value="3">&#8595;</option>
		</select>
	</div>
</template>
<script>
/** @format */

export default {
	name: "CourseFairwaySelect",
	props: {
		courseHole: {
			type: Object,
			required: true
		},
		isReadOnly: {
			type: Boolean,
			default: false
		}
	},
	created() {
		if (this.courseHole.fairway === null) this.courseHole.fairway = true;
	},
	computed: {
		fairwayValue() {
			switch (this.fairwayPos) {
				case 4:
					return "?";
					break;
				case -1:
					return "&#10003;";
					break;
				case 1:
					return "&#8592;";
					break;
				case 2:
					return "&#8594;";
					break;
				case 0:
					return "&#8593;";
					break;
				case 3:
					return "&#8595;";
					break;
			}
		},
		fairwayPos: {
			get() {
				if (!!this.courseHole.fairway == true) return -1;
				return parseInt(this.courseHole.fairway_miss);
			},
			set(v) {
				const value = parseInt(v);
				if (value == -1) {
					this.courseHole.fairway = true;
					this.courseHole.fairway_miss = 4;
				} else {
					this.courseHole.fairway = false;
					this.courseHole.fairway_miss = v;
				}
				this.$emit("updated", this.courseHole);
			}
		}
	}
};
</script>
